define(["require", "exports"], function (require, exports) {
    "use strict";
    var strings = /** @class */ (function () {
        function strings(str) {
            this.s = str;
        }
        strings.S = function (s) {
            return new strings(s);
        };
        strings.prototype.humanize = function () {
            if (this.s === null || this.s === undefined)
                return this.constructor('');
            var s = this.underscore().replace(/_id$/, '').replace(/_/g, ' ').trim().capitalize();
            return new strings(s.s);
        };
        strings.prototype.underscore = function () {
            var s = this.s.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/([A-Z\d]+)([A-Z][a-z])/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
            return new strings(s);
        };
        strings.prototype.capitalize = function () {
            return new strings(this.s.substr(0, 1).toUpperCase() + this.s.substring(1).toLowerCase());
        };
        strings.prototype.replace = function (searchValue, replaceValue) {
            var s;
            s = this.s.replace(searchValue, replaceValue);
            return new strings(s);
        };
        strings.prototype.trim = function () {
            var s;
            s = this.s.trim();
            return new strings(s);
        };
        strings.prototype.hashCode = function () {
            var hash = 0, i, chr, len;
            if (this.s.length === 0)
                return hash;
            for (i = 0, len = this.s.length; i < len; i++) {
                chr = this.s.charCodeAt(i);
                hash = ((hash << 5) - hash) + chr;
                hash |= 0; // Convert to 32bit integer
            }
            return hash;
        };
        ;
        strings.prototype.toString = function () {
            return this.s;
        };
        return strings;
    }());
    (window['global'] || (window['global'] = {})).strings = strings;
    return strings;
});
//# sourceMappingURL=strings.js.map


//////////////////
// WEBPACK FOOTER
// ./build/utils/strings.js
// module id = 67
// module chunks = 2